export const EMPLOYMENT_HISTORY_MIN_MONTHS_EMPLOYED = 48
export const EMPLOYMENT_HISTORY_MIN_MONTHS_EMPLOYED_YEARS_BACK = 20

export const EMPLOYMENT_ROUTES = {
  ONBOARDING_EMPLOYMENT_HISTORY: '/onboarding/employment-history/',
  ONBOARDING_EMPLOYMENT_HISTORY_ADD: '/onboarding/employment-history/add-position/',
  ONBOARDING_EMPLOYMENT_HISTORY_EDIT: '/onboarding/employment-history/edit-position/:id/',
}
